import IconButton from '@mui/material/IconButton'
import React, { useState } from 'react'

export default function IButton ({
  isSidebar,
  handleClick,
  children,
  isMenu,
  opened
}) {
  const [isClicked, setIsClicked] = useState(opened || false)

  const toggleClick = () => {
    setIsClicked(!isClicked)
  }

  const menuOpened = (e) => {
    setIsClicked(opened)
    handleClick(e)
  }

  return (
    <IconButton
      className={
        isSidebar
          ? `${isClicked}`
          : isMenu
            ? `${opened}`
            : undefined
      }
      onClick={isMenu ? menuOpened : toggleClick}
      disableRipple
      sx={(theme) => ({
        backgroundColor: opened ? '#EDEDED' : 'transparent',
        border: '2px solid transparent',
        borderRadius: 7,
        height: 32,
        width: 32,
        '&:hover': {
          border: `2px solid ${theme.palette.secondary.accent}`
        }
      })}
    >
      {children}
    </IconButton>
  )
}
